const formatter = new Intl.NumberFormat();

export const getThousand = (money: number) => {
  return new Intl.NumberFormat('ru-RU').format(money);
};
